import React from 'react';
import {connect} from "react-redux";
import {Switch} from "react-router-dom";
import {ThemeProvider, withStyles} from '@material-ui/core/styles';

import CssBaseline from "@material-ui/core/CssBaseline";
import Hidden from "@material-ui/core/Hidden";
import Navigator from "../../components/Navigator";
import Header from "../../components/Header";
import Query from "../../pages/Query/Query";
import QueryContainer from "../../pages/Query/QueryContainer";
import Profile from "../../pages/Profile/Profile";
import Support from "../../pages/Support/Support";
import {
  setNavigationDrawer
} from "../../actions/session"

import {ProtectedRoute, ProtectedAdminRoute} from "../../util/route";
import { theme } from "./theme";
import DashboardHome from "./DashboardHome";
import Invite from "../Admin/Invite";


import UserList from "../Admin/users/UserList"
import UserEdit from "../Admin/users/UserEdit";
import UserDelete from "../Admin/users/UserDelete";


import AdminConnections from "../Admin/connections/ConnectionTableContainer";
import ConnectionEdit from "../Admin/connections/ConnectionEdit";
import ConnectionNew from "../Admin/connections/ConnectionNew";
import ConnectionDelete from "../Admin/connections/ConnectionDelete";
import ConnectionRequest from "../ConnectionRequest/ConnectionRequest";

import Content from "../Admin/contentManager/ContentTableContainer";
import ContentEdit from "../Admin/contentManager/ContentEdit";
import ContentNew from "../Admin/contentManager/ContentNew";
import ContentDelete from "../Admin/contentManager/ContentDelete";

import AdminTags from "../Admin/tags/TagTableContainer";
import TagEdit from "../Admin/tags/TagEdit";
import TagDelete from "../Admin/tags/TagDelete";

import {ToastContainer} from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LinearLoadingBar from "../../components/LinearLoadingBar";
import ChangePassword from "../ChangePassword/ChangePassword";

let themeCustom = {
  ...theme,
  overrides: {
    MuiDrawer: {
      paper: {
        backgroundColor: '#18202c',
      },
    },
    MuiButton: {
      label: {
        textTransform: 'none',
      },
      contained: {
        boxShadow: 'none',
        '&:active': {
          boxShadow: 'none',
        },
      },
    },
    MuiTabs: {
      root: {
        marginLeft: theme.spacing(1),
      },
      indicator: {
        height: 3,
        borderTopLeftRadius: 3,
        borderTopRightRadius: 3,
        backgroundColor: theme.palette.common.white,
      },
    },
    MuiIconButton: {
      root: {
        padding: theme.spacing(1),
      },
    },
    MuiTooltip: {
      tooltip: {
        borderRadius: 4,
      },
    },
    MuiDivider: {
      root: {
        backgroundColor: '#404854',
      },
    },
    MuiListItemText: {
      primary: {
        fontWeight: theme.typography.fontWeightMedium,
      },
    },
    MuiListItemIcon: {
      root: {
        color: 'inherit',
        marginRight: 0,
        '& svg': {
          fontSize: 20,
        },
      },
    },
    MuiAvatar: {
      root: {
        width: 32,
        height: 32,
      },
    },
  },
};

const drawerWidth = 256;

const styles = {
  root: {
    display: 'flex',
    minHeight: '100vh',
  },
  drawer: {
    [theme.breakpoints.up('sm')]: {
      width: drawerWidth,
      flexShrink: 0,
    },
  },
  app: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
  },
  main: {
    flex: 1,
    padding: theme.spacing(6, 4),
    background: '#eaeff1',
  },
};

let Dashboard = (props) => {
  const {classes} = props;
  // const [mobileOpen, setMobileOpen] = React.useState(false);

  const handleDrawerToggle = () => {
    props.setNavigationDrawer(!props.open);
  };

  return (
    <ThemeProvider theme={themeCustom}>
      <div className={classes.root}>
        <CssBaseline/>
        <ToastContainer autoClose={4000}/>
        <nav className={classes.drawer}>
          <Hidden smUp implementation="js">
            <Navigator
              PaperProps={{style: {width: drawerWidth}}}
              variant="temporary"
              // open={mobileOpen}
              onClose={handleDrawerToggle}
             />
          </Hidden>
          <Hidden xsDown implementation="css">
            <Navigator PaperProps={{style: {width: drawerWidth}}}/>
          </Hidden>
        </nav>
        <div className={classes.app}>
          <LinearLoadingBar />
          <Header onDrawerToggle={handleDrawerToggle}/>
          <main className={classes.main}>

            <Switch>
              <ProtectedRoute exact path="/dashboard" component={DashboardHome}/>
              <ProtectedRoute exact path="/dashboard/query" component={Query}/>
              <ProtectedRoute exact path="/dashboard/query/connectionRequest" component={ConnectionRequest}/>
              <ProtectedRoute exact path="/dashboard/profile" component={Profile}/>
              <ProtectedRoute exact path="/dashboard/support" component={Support}/>
              <ProtectedRoute exact path="/dashboard/changePassword" component={ChangePassword}/>
              <ProtectedAdminRoute path="/dashboard/admin/users" exact component={UserList}/>
              <ProtectedAdminRoute path="/dashboard/admin/users/edit/:id" exact component={UserEdit}/>
              <ProtectedAdminRoute path="/dashboard/admin/users/delete/:id" exact component={UserDelete}/>
              <ProtectedAdminRoute path="/dashboard/admin/connections" exact component={AdminConnections}/>
              <ProtectedAdminRoute path="/dashboard/admin/connections/edit/:id" exact component={ConnectionEdit}/>
              <ProtectedAdminRoute path="/dashboard/admin/connections/delete/:id" exact component={ConnectionDelete}/>
              <ProtectedAdminRoute path="/dashboard/admin/connections/new" exact component={ConnectionNew}/>

              <ProtectedAdminRoute path="/dashboard/admin/contentManager" exact component={Content}/>
              <ProtectedAdminRoute path="/dashboard/admin/contentManager/edit/:id" exact component={ContentEdit}/>
              <ProtectedAdminRoute path="/dashboard/admin/contentManager/delete/:id" exact component={ContentDelete}/>
              <ProtectedAdminRoute path="/dashboard/admin/contentManager/new" exact component={ContentNew}/>

              <ProtectedAdminRoute path="/dashboard/admin/tags" exact component={AdminTags}/>
              <ProtectedAdminRoute path="/dashboard/admin/tags/edit/:id" exact component={TagEdit}/>
              <ProtectedAdminRoute path="/dashboard/admin/tags/delete/:id" exact component={TagDelete}/>
              <ProtectedAdminRoute path="/dashboard/admin/invite" exact component={Invite}/>
              <ProtectedAdminRoute path="/dashboard/queryTest" component={QueryContainer}/>
            </Switch>
          </main>
        </div>
      </div>
    </ThemeProvider>
  );
};

const mapStateToProps = (state) => {
  const {session} = state;
  return {
    session,
    open: state.ui.navigationDrawerStatus
  }
};

Dashboard = withStyles(styles)(Dashboard);

Dashboard = connect(
  mapStateToProps,
  {setNavigationDrawer}
)(Dashboard);

export default Dashboard;